import { PaymentCardSVG } from '@svgComponents/paymentCardSVG/PaymentCardSVG';
import { RocketSVG } from '@svgComponents/rocketSVG/RocketSVG';

// eslint-disable-next-line import/no-default-export
export default () => [
    {
        title: 'Über Mindestrückzahlungen',
        description: (
            <>
                eBay leitet den von Ihnen{' '}
                <strong>
                    festgelegten Teil Ihrer Umsätze automatisch als Rückzahlung
                    an iwoca weiter.
                </strong>{' '}
                Alle 60 Tage muss die Summe dieser Rückzahlungen mindestens die
                Hälfte Ihrer bis dahin erwarteten Rückzahlungen entsprechen.
                Sollten sinkende Umsätze dazu führen, dass diese
                Mindestrückzahlung nicht erreicht wird, ziehen wir den
                Differenzbetrag per Lastschrift von Ihrem Geschäftskonto ein.
            </>
        ),
        backgroundIcon: <PaymentCardSVG />
    },
    {
        title: 'Kann ich eine Kreditaufstockung beantragen?',
        description: (
            <>
                Sie können eine Kreditaufstockung anfragen,{' '}
                <strong>
                    wenn Sie weniger als 70% Ihres Kreditsrahmens in Anspruch
                    nehmen.
                </strong>{' '}
                In Ihrem Kundenprofil sehen Sie, ob eine Aufstockung möglich
                ist. Ist Ihre Anfrage erfolgreich, beginnt wieder eine neue
                Laufzeit für die gesamte Kredithöhe.
                <br /> <br />
                Die Anfrage sowie die Bearbeitung sind für Sie{' '}
                <strong>kostenlos und unverbindlich.</strong> Wenn wir Ihnen
                einen Kredit anbieten, haben Sie einige Tage Zeit zu
                entscheiden, ob Sie den Kredit ganz oder auch nur teilweise
                aufnehmen. <br />
                <br />
                Wir vergeben Kredite von 1.000 € bis 500.000 €.
            </>
        ),
        backgroundIcon: <RocketSVG />
    }
];
